document.addEventListener('DOMContentLoaded', function() {
  const section = document.getElementById(
    window.pahlowmediaSectionId
  );

  if (!section) return;

  const variantContainers = section.querySelectorAll(
    '.variant__container'
  );

  const unitPriceElement = section.querySelector(
    '[data-unit-price]'
  );

  let deliveryUpdateInterval = null;

  function updateUnitPrice(variantId) {
    const selectedVariant = section.querySelector(
      `[data-variant-id="${variantId}"]`
    );

    if (!selectedVariant || !unitPriceElement) return;

    const unitPrice =
      selectedVariant.dataset.variantUnitPrice;

    const unitPriceMeasurement =
      selectedVariant.dataset.variantUnitMeasurement;

    if (unitPrice) {
      unitPriceElement.innerHTML =
        `(${unitPrice} / ${unitPriceMeasurement})`;

      unitPriceElement.style.display = '';
    } else {
      unitPriceElement.style.display = 'none';
    }
  }

  function formatDeliveryDate(date) {
    const day = String(
      date.getDate()
    ).padStart(2, '0');

    const month = String(
      date.getMonth() + 1
    ).padStart(2, '0');

    return `${day}.${month}.`;
  }

  function getNextWeekday(date, targetWeekday) {
    const result = new Date(date);
    const currentWeekday = result.getDay();

    let daysUntilTarget =
      (targetWeekday - currentWeekday + 7) % 7;

    if (daysUntilTarget === 0) {
      daysUntilTarget = 7;
    }

    result.setDate(
      result.getDate() + daysUntilTarget
    );

    return result;
  }

  function createCountdownText(currentTime, cutoff) {
    const diffMs = cutoff - currentTime;

    const hours = Math.floor(
      diffMs / (1000 * 60 * 60)
    );

    const minutes = Math.floor(
      (diffMs / (1000 * 60)) % 60
    );

    return (
      `<span class="delivery-time-left" ` +
      `style="color: #999999 !important; ` +
      `font-size: 0.8em; ` +
      `white-space: nowrap;">` +
      `Bestelle innerhalb ${hours} Std. ` +
      `${minutes} Min.` +
      `</span>`
    );
  }

  function updateDeliveryMessage() {
    const deliverySpan = document.getElementById(
      'delivery-message'
    );

    if (!deliverySpan) return;

    const stockContainer = document.querySelector(
      '[data-variant-inventory]'
    );

    if (
      stockContainer &&
      stockContainer.dataset.isGiftCard === 'true'
    ) {
      return;
    }

    const beforeCutoffText =
      window.pahlowmediaDeliverySettings
        ?.beforeCutoffText ||
      'Morgen geliefert';

    const afterCutoffText =
      window.pahlowmediaDeliverySettings
        ?.afterCutoffText ||
      'Übermorgen geliefert';

    const cutoffTime =
      window.pahlowmediaDeliverySettings
        ?.cutoffTime ||
      '15:30';

    const [cutoffHour, cutoffMinute] = cutoffTime
      .split(':')
      .map(number => parseInt(number, 10));

    const now = new Date();

    const zurichTime = new Date(
      now.toLocaleString('en-US', {
        timeZone: 'Europe/Zurich'
      })
    );

    const cutoff = new Date(zurichTime);

    cutoff.setHours(
      cutoffHour,
      cutoffMinute,
      0,
      0
    );

    const weekday = zurichTime.getDay();

    const isFriday = weekday === 5;
    const isSaturday = weekday === 6;
    const isSunday = weekday === 0;
    const isBeforeCutoff = zurichTime < cutoff;

    let deliveryText = '';
    let timeLeftText = '';

    if (isFriday && isBeforeCutoff) {
      // Friday orders before the cutoff arrive Monday
      const monday = getNextWeekday(
        zurichTime,
        1
      );

      deliveryText =
        `Geliefert am Montag, ` +
        `${formatDeliveryDate(monday)}`;

      timeLeftText = createCountdownText(
        zurichTime,
        cutoff
      );
    } else if (
      (isFriday && !isBeforeCutoff) ||
      isSaturday ||
      isSunday
    ) {
      // Friday after the cutoff through Sunday arrives Tuesday
      const tuesday = getNextWeekday(
        zurichTime,
        2
      );

      deliveryText =
        `Geliefert am Dienstag, ` +
        `${formatDeliveryDate(tuesday)}`;
    } else if (isBeforeCutoff) {
      deliveryText = beforeCutoffText;

      timeLeftText = createCountdownText(
        zurichTime,
        cutoff
      );
    } else {
      deliveryText = afterCutoffText;
    }

    deliverySpan.innerHTML =
      `${deliveryText} ${timeLeftText}`.trim();
  }

  function startDeliveryInterval() {
    if (deliveryUpdateInterval) {
      clearInterval(deliveryUpdateInterval);
    }

    updateDeliveryMessage();

    deliveryUpdateInterval = setInterval(
      updateDeliveryMessage,
      60000
    );
  }

  variantContainers.forEach(container => {
    container.addEventListener('click', function() {
      const variantId = container.dataset.variantId;

      updateUnitPrice(variantId);
      startDeliveryInterval();
    });
  });

  if (variantContainers.length > 0) {
    const firstVariant = section.querySelector(
      '.variant__container'
    );

    if (firstVariant) {
      updateUnitPrice(
        firstVariant.dataset.variantId
      );
    }
  }

  window.updateDeliveryTime =
    updateDeliveryMessage;

  startDeliveryInterval();
});